import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = { class: "text-2xl sm:text-3xl font-bold text-gray-900 flex items-center gap-3" }
const _hoisted_4 = { class: "p-2 bg-[#22282F]/10 rounded-lg" }
const _hoisted_5 = { class: "bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden mb-6" }
const _hoisted_6 = { class: "bg-gradient-to-r from-[#22282F] to-[#2a3139] px-6 py-6 flex items-center gap-4" }
const _hoisted_7 = { class: "w-16 h-16 rounded-full bg-white/15 flex items-center justify-center text-white text-2xl font-semibold flex-shrink-0" }
const _hoisted_8 = { class: "min-w-0" }
const _hoisted_9 = { class: "text-lg font-semibold text-white truncate" }
const _hoisted_10 = { class: "text-sm text-white/70 truncate" }
const _hoisted_11 = { class: "divide-y divide-gray-100" }
const _hoisted_12 = { class: "px-6 py-4 flex items-start gap-3" }
const _hoisted_13 = { class: "text-sm text-gray-900 font-medium" }
const _hoisted_14 = { class: "px-6 py-4 flex items-start gap-3" }
const _hoisted_15 = { class: "text-sm text-gray-900 font-medium" }
const _hoisted_16 = { class: "px-6 py-4 flex items-start gap-3" }
const _hoisted_17 = { class: "text-sm text-gray-900 font-medium" }
const _hoisted_18 = {
  key: 0,
  class: "px-6 py-4 flex items-start gap-3"
}
const _hoisted_19 = { class: "text-xs text-gray-400" }
const _hoisted_20 = { class: "text-sm text-gray-900 font-medium" }
const _hoisted_21 = { class: "bg-white border border-gray-200 rounded-xl shadow-sm p-6" }
const _hoisted_22 = { class: "flex items-start justify-between gap-4 flex-wrap" }
const _hoisted_23 = { class: "flex items-start gap-4" }
const _hoisted_24 = { class: "mt-2" }
const _hoisted_25 = {
  key: 0,
  class: "inline-flex items-center gap-1.5 text-xs text-gray-400"
}
const _hoisted_26 = {
  key: 2,
  class: "text-xs text-gray-400 ml-2"
}
const _hoisted_27 = {
  key: 0,
  class: "mt-5 p-3 bg-red-50 border border-red-200 rounded-lg flex items-start gap-2"
}
const _hoisted_28 = { class: "text-sm text-red-800" }
const _hoisted_29 = {
  key: 1,
  class: "mt-6 pt-6 border-t border-gray-200"
}
const _hoisted_30 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8"
}
const _hoisted_31 = {
  key: 1,
  class: "flex flex-col sm:flex-row gap-6 items-center sm:items-start"
}
const _hoisted_32 = { class: "p-3 bg-white border border-gray-200 rounded-xl shadow-sm flex-shrink-0" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "flex-1 w-full" }
const _hoisted_35 = {
  key: 1,
  class: "mb-3 flex items-center justify-between gap-2 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2"
}
const _hoisted_36 = { class: "text-xs text-gray-800 break-all" }
const _hoisted_37 = { class: "flex items-center gap-2" }
const _hoisted_38 = ["value", "onInput", "onKeydown", "disabled"]
const _hoisted_39 = { class: "flex gap-2" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"
}
const _hoisted_42 = {
  key: 2,
  class: "mt-6 pt-6 border-t border-gray-200"
}
const _hoisted_43 = { class: "flex items-center gap-2" }
const _hoisted_44 = ["value", "onInput", "onKeydown", "disabled"]
const _hoisted_45 = { class: "flex gap-2" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = {
  key: 0,
  class: "w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"
}

import { ref, computed, onMounted, nextTick } from 'vue'
import {
  UserCircle, User as UserIcon, Mail, ShieldCheck, ShieldAlert, Building2,
  AlertCircle, KeyRound, Copy,
} from 'lucide-vue-next'
import AdminLayout from '@/layouts/AdminLayout.vue'
import { useAuthStore } from '@/store/auth'
import { useToast } from '@/utils/toast'

type Mode = 'idle' | 'enable' | 'disable'

export default /*@__PURE__*/_defineComponent({
  __name: 'ProfilView',
  setup(__props) {

const store = useAuthStore()
const toast = useToast()
const user = computed(() => store.user)

const initials = computed(() => {
  const name = user.value?.full_name || user.value?.username || ''
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]?.toUpperCase()).join('') || '?'
})

const scopeType = computed(() => (user.value?.ambassade ? 'Ambassade' : 'Direction'))
const scopeLabel = computed(() => user.value?.ambassade?.nom || user.value?.direction?.nom || '')

const enabled = ref(false)
const confirmedAt = ref<string | null>(null)
const loadingStatus = ref(true)

const mode = ref<Mode>('idle')
const loadingQr = ref(false)
const busy = ref(false)
const error = ref('')

const qrCode = ref<string | null>(null)
const secret = ref<string | null>(null)
const showSecret = ref(false)

const otp = ref<string[]>(Array(6).fill(''))
const otpRefs = ref<Array<HTMLInputElement | null>>([])
const isComplete = computed(() => otp.value.every((d) => /^\d$/.test(d)))

onMounted(loadStatus)

async function loadStatus() {
  loadingStatus.value = true
  const s = await store.status2FA()
  enabled.value = s.enabled
  confirmedAt.value = s.confirmedAt
  loadingStatus.value = false
}

function formatDate(iso: string) {
  try {
    return new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })
  } catch {
    return iso
  }
}

async function startEnable() {
  error.value = ''
  resetCode()
  mode.value = 'enable'
  loadingQr.value = true
  const result = await store.setup2FA()
  loadingQr.value = false
  if (result.success) {
    qrCode.value = result.qrCode || null
    secret.value = result.secret || null
    await nextTick()
    focusIndex(0)
  } else {
    error.value = result.error || 'Impossible de générer le QR code'
    mode.value = 'idle'
  }
}

function startDisable() {
  error.value = ''
  resetCode()
  mode.value = 'disable'
  nextTick(() => focusIndex(0))
}

function cancel() {
  mode.value = 'idle'
  error.value = ''
  resetCode()
}

async function confirmEnable() {
  const code = otp.value.join('')
  if (!/^\d{6}$/.test(code)) return
  busy.value = true
  error.value = ''
  const result = await store.confirm2FA(code)
  busy.value = false
  if (result.status === 'success') {
    toast.success('2FA activée', 'La double authentification est maintenant active.')
    mode.value = 'idle'
    await loadStatus()
  } else {
    error.value = (result as any).error || 'Code incorrect'
    resetCode()
  }
}

async function confirmDisable() {
  const code = otp.value.join('')
  if (!/^\d{6}$/.test(code)) return
  busy.value = true
  error.value = ''
  const result = await store.disable2FA(code)
  busy.value = false
  if (result.success) {
    toast.success('2FA désactivée', 'La double authentification a été désactivée.')
    mode.value = 'idle'
    await loadStatus()
  } else {
    error.value = result.error || 'Code incorrect'
    resetCode()
  }
}

async function copySecret() {
  if (secret.value) {
    try {
      await navigator.clipboard.writeText(secret.value)
      toast.success('Copié', 'La clé a été copiée dans le presse-papiers.')
    } catch { /* noop */ }
  }
}

// --- Gestion des 6 cases ---
function setOtpRef(el: any, idx: number) {
  otpRefs.value[idx] = (el as HTMLInputElement) || null
}
function focusIndex(i: number) {
  const el = otpRefs.value[i]
  el?.focus()
  el?.select()
}
function distribute(digits: string) {
  const ds = digits.replace(/\D/g, '').slice(0, 6)
  for (let i = 0; i < 6; i++) otp.value[i] = ds[i] || ''
  const firstEmpty = otp.value.findIndex((d) => !d)
  focusIndex(firstEmpty === -1 ? 5 : firstEmpty)
}
function handleInput(e: Event, idx: number) {
  const target = e.target as HTMLInputElement
  const val = (target.value || '').replace(/\D/g, '')
  if (val.length > 1) { distribute(val); return }
  otp.value[idx] = val
  if (val && idx < 5) focusIndex(idx + 1)
}
function onKeydown(e: KeyboardEvent, idx: number) {
  if (e.key === 'Backspace') {
    if (otp.value[idx]) otp.value[idx] = ''
    else if (idx > 0) { otp.value[idx - 1] = ''; focusIndex(idx - 1) }
    e.preventDefault()
  } else if (e.key === 'ArrowLeft' && idx > 0) { focusIndex(idx - 1); e.preventDefault() }
  else if (e.key === 'ArrowRight' && idx < 5) { focusIndex(idx + 1); e.preventDefault() }
}
function onPaste(e: ClipboardEvent) {
  const digits = (e.clipboardData?.getData('text') || '').replace(/\D/g, '')
  if (!digits) return
  e.preventDefault()
  distribute(digits)
}
function resetCode() {
  otp.value = Array(6).fill('')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(UserCircle), { class: "w-7 h-7 sm:w-8 sm:h-8 text-[#22282F]" })
            ]),
            _cache[4] || (_cache[4] = _createTextVNode(" Mon profil "))
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-gray-500 mt-2" }, "Vos informations et la sécurité de votre compte", -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(initials.value), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(user.value?.full_name || user.value?.username), 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(user.value?.role?.nom || '—'), 1)
            ])
          ]),
          _createElementVNode("dl", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_unref(UserIcon), { class: "w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" }),
              _createElementVNode("div", null, [
                _cache[6] || (_cache[6] = _createElementVNode("dt", { class: "text-xs text-gray-400" }, "Nom d'utilisateur", -1)),
                _createElementVNode("dd", _hoisted_13, _toDisplayString(user.value?.username || '—'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_unref(Mail), { class: "w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" }),
              _createElementVNode("div", null, [
                _cache[7] || (_cache[7] = _createElementVNode("dt", { class: "text-xs text-gray-400" }, "Email", -1)),
                _createElementVNode("dd", _hoisted_15, _toDisplayString(user.value?.email || '—'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_unref(ShieldCheck), { class: "w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" }),
              _createElementVNode("div", null, [
                _cache[8] || (_cache[8] = _createElementVNode("dt", { class: "text-xs text-gray-400" }, "Rôle", -1)),
                _createElementVNode("dd", _hoisted_17, _toDisplayString(user.value?.role?.nom || '—'), 1)
              ])
            ]),
            (scopeLabel.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_unref(Building2), { class: "w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" }),
                  _createElementVNode("div", null, [
                    _createElementVNode("dt", _hoisted_19, _toDisplayString(scopeType.value), 1),
                    _createElementVNode("dd", _hoisted_20, _toDisplayString(scopeLabel.value), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", {
                class: _normalizeClass(['p-3 rounded-xl', enabled.value ? 'bg-green-100' : 'bg-gray-100'])
              }, [
                (enabled.value)
                  ? (_openBlock(), _createBlock(_unref(ShieldCheck), {
                      key: 0,
                      class: "w-6 h-6 text-green-600"
                    }))
                  : (_openBlock(), _createBlock(_unref(ShieldAlert), {
                      key: 1,
                      class: "w-6 h-6 text-gray-500"
                    }))
              ], 2),
              _createElementVNode("div", null, [
                _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900" }, "Double authentification (2FA)", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-sm text-gray-500 mt-0.5 max-w-md" }, " Ajoute une étape de vérification par code temporaire (Google Authenticator, Authy…) à chaque connexion. ", -1)),
                _createElementVNode("div", _hoisted_24, [
                  (loadingStatus.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _cache[9] || (_cache[9] = [
                        _createElementVNode("div", { class: "w-3 h-3 border-2 border-gray-300 border-t-gray-500 rounded-full animate-spin" }, null, -1),
                        _createTextVNode(" Vérification… ")
                      ])))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass([
                    'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium',
                    enabled.value ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'
                  ])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['w-1.5 h-1.5 rounded-full', enabled.value ? 'bg-green-500' : 'bg-amber-500'])
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(enabled.value ? 'Activée' : 'Non configurée'), 1)
                      ], 2)),
                  (enabled.value && confirmedAt.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, " depuis le " + _toDisplayString(formatDate(confirmedAt.value)), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (!loadingStatus.value && mode.value === 'idle')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (enabled.value ? startDisable() : startEnable())),
                  class: _normalizeClass([
              'px-4 py-2 rounded-lg text-sm font-medium transition-colors',
              enabled.value
                ? 'bg-red-50 text-red-700 border border-red-200 hover:bg-red-100'
                : 'bg-[#22282F] text-white hover:bg-[#2a3139]'
            ])
                }, _toDisplayString(enabled.value ? 'Désactiver' : 'Activer'), 3))
              : _createCommentVNode("", true)
          ]),
          (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createVNode(_unref(AlertCircle), { class: "w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" }),
                _createElementVNode("p", _hoisted_28, _toDisplayString(error.value), 1)
              ]))
            : _createCommentVNode("", true),
          (mode.value === 'enable')
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                (loadingQr.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _cache[12] || (_cache[12] = [
                      _createElementVNode("div", { class: "w-10 h-10 border-4 border-[#22282F]/30 border-t-[#22282F] rounded-full animate-spin mb-3" }, null, -1),
                      _createElementVNode("p", { class: "text-gray-500 text-sm" }, "Génération du QR code…", -1)
                    ])))
                  : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        (qrCode.value)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: qrCode.value,
                              alt: "QR code 2FA",
                              class: "w-40 h-40"
                            }, null, 8, _hoisted_33))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-sm text-gray-700 mb-1" }, " Scannez ce QR code avec votre application d'authentification, puis saisissez le code généré. ", -1)),
                        (secret.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (showSecret.value = !showSecret.value)),
                              class: "text-xs text-[#22282F] hover:underline flex items-center gap-1 mb-3"
                            }, [
                              _createVNode(_unref(KeyRound), { class: "w-3.5 h-3.5" }),
                              _createTextVNode(" " + _toDisplayString(showSecret.value ? 'Masquer la clé' : 'Afficher la clé manuelle'), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (showSecret.value && secret.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              _createElementVNode("code", _hoisted_36, _toDisplayString(secret.value), 1),
                              _createElementVNode("button", {
                                type: "button",
                                onClick: copySecret,
                                class: "text-gray-400 hover:text-[#22282F]",
                                title: "Copier"
                              }, [
                                _createVNode(_unref(Copy), { class: "w-4 h-4" })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("form", {
                          onSubmit: _withModifiers(confirmEnable, ["prevent"]),
                          class: "space-y-4"
                        }, [
                          _createElementVNode("div", _hoisted_37, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (_, i) => {
                              return _createElementVNode("input", {
                                key: i,
                                value: otp.value[i],
                                onInput: ($event: any) => (handleInput($event, i)),
                                onKeydown: ($event: any) => (onKeydown($event, i)),
                                onPaste: _cache[2] || (_cache[2] = ($event: any) => (onPaste($event))),
                                inputmode: "numeric",
                                pattern: "[0-9]*",
                                type: "tel",
                                disabled: busy.value,
                                class: "w-10 h-12 sm:w-11 sm:h-12 text-center text-base font-semibold rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/15 transition-all disabled:opacity-50",
                                ref_for: true,
                                ref: el => setOtpRef(el, i),
                                maxlength: "1"
                              }, null, 40, _hoisted_38)
                            }), 64))
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("button", {
                              type: "submit",
                              disabled: busy.value || !isComplete.value,
                              class: "px-4 py-2 bg-[#22282F] text-white rounded-lg text-sm font-medium hover:bg-[#2a3139] transition-colors disabled:opacity-50 flex items-center gap-2"
                            }, [
                              (busy.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41))
                                : _createCommentVNode("", true),
                              _cache[13] || (_cache[13] = _createTextVNode(" Confirmer l'activation "))
                            ], 8, _hoisted_40),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: cancel,
                              class: "px-4 py-2 text-sm text-gray-500 hover:text-gray-700"
                            }, " Annuler ")
                          ])
                        ], 32)
                      ])
                    ]))
              ]))
            : _createCommentVNode("", true),
          (mode.value === 'disable')
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-sm text-gray-700 mb-4" }, " Saisissez un code de votre application d'authentification pour confirmer la désactivation. ", -1)),
                _createElementVNode("form", {
                  onSubmit: _withModifiers(confirmDisable, ["prevent"]),
                  class: "space-y-4"
                }, [
                  _createElementVNode("div", _hoisted_43, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (_, i) => {
                      return _createElementVNode("input", {
                        key: i,
                        value: otp.value[i],
                        onInput: ($event: any) => (handleInput($event, i)),
                        onKeydown: ($event: any) => (onKeydown($event, i)),
                        onPaste: _cache[3] || (_cache[3] = ($event: any) => (onPaste($event))),
                        inputmode: "numeric",
                        pattern: "[0-9]*",
                        type: "tel",
                        disabled: busy.value,
                        class: "w-10 h-12 sm:w-11 sm:h-12 text-center text-base font-semibold rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:border-[#8C0004] focus:ring-2 focus:ring-[#8C0004]/15 transition-all disabled:opacity-50",
                        ref_for: true,
                        ref: el => setOtpRef(el, i),
                        maxlength: "1"
                      }, null, 40, _hoisted_44)
                    }), 64))
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("button", {
                      type: "submit",
                      disabled: busy.value || !isComplete.value,
                      class: "px-4 py-2 bg-[#8C0004] text-white rounded-lg text-sm font-medium hover:bg-[#a30005] transition-colors disabled:opacity-50 flex items-center gap-2"
                    }, [
                      (busy.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47))
                        : _createCommentVNode("", true),
                      _cache[15] || (_cache[15] = _createTextVNode(" Désactiver la 2FA "))
                    ], 8, _hoisted_46),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: cancel,
                      class: "px-4 py-2 text-sm text-gray-500 hover:text-gray-700"
                    }, " Annuler ")
                  ])
                ], 32)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})